import { Box, CircularProgress } from "@mui/material";

/** Lightweight route chunk fallback — not tied to global API loader state. */
const RouteSuspenseFallback = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "40vh",
      width: "100%",
    }}
  >
    <CircularProgress size={36} />
  </Box>
);

export default RouteSuspenseFallback;
